import { useMemo } from "react";
import { DEVICE_CATALOGUE, type DeviceOption } from "./epocus-exam-constants";
import { selectActiveProgram, useMyPrograms } from "./use-active-program";

/**
 * An empty list means unconfigured, which enables every device — so a program
 * naming only ids this build has never heard of must fall back to the whole
 * catalogue rather than leaving the clinician with nothing to pick.
 */
export const selectEnabledDevices = (
  enabled: readonly string[] | undefined,
): readonly DeviceOption[] => {
  if (!enabled || enabled.length === 0) return DEVICE_CATALOGUE;

  const enabledSet = new Set(enabled);
  const narrowed = DEVICE_CATALOGUE.filter((device) =>
    enabledSet.has(device.id),
  );

  return narrowed.length === 0 ? DEVICE_CATALOGUE : narrowed;
};

export const useEnabledDevices = (): readonly DeviceOption[] => {
  const { programs } = useMyPrograms();

  return useMemo(
    () => selectEnabledDevices(selectActiveProgram(programs)?.enabledDeviceIds),
    [programs],
  );
};
